<template>
	<div class="menu-nav-group" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
		<div class="menu-nav-group-header">
			<div v-if="title" :class="{bold: bold}" class="menu-nav-group-header-text">{{title}}</div>
			<transition v-if="showButton" name="fade">
				<t-icon-button
					v-show="showHeaderButton"
					icon="cog"
					type="bp"
					iconSize="xs"
					appearance="minimal"
					size="small"
					@click="$emit('click', $event)"
				/>
			</transition>
		</div>
		<slot/>
	</div>
</template>

<script>
export default {
	name: 'TMenuNavGroup',
	props: {
		title: String,
		bold: Boolean,
		showButton: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return { showHeaderButton: false };
	},
	methods: {
		onMouseEnter() {
			if (!this.showButton || !('click' in this.$listeners)) return;
			this.showHeaderButton = true;
		},
		onMouseLeave() {
			if (!this.showButton) return;
			this.showHeaderButton = false;
		}
	},
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/text';
	@import '~@/components/evergreen/scss/colors';

	.menu-nav-group {
		box-sizing: border-box;
		padding-top: 8px;
		padding-bottom: 8px;
	}

	.menu-nav-group-header {
		display:flex;
		justify-content: space-between;
		align-items: center;
		height: 24px;
		margin-left: 44px;
		margin-right: 16px;
		margin-top: 8px;
		margin-bottom: 8px;
	}

	.menu-nav-group-header-text {
		@extend %font-families-ui;
		user-select: none;
		letter-spacing: 0.6px;
		font-size: 11px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.6px;
		color: get-color($text, 'muted');
		text-transform: uppercase;
		&.bold {
			font-weight: 600;
		}
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .2s ease;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>
